import { StaticBaseDao } from '@/dao';
import { Organizer } from '@/objects/generated';

export class OrganizerDao extends StaticBaseDao {
    public static async GetOrganizerById(organizerId: number): Promise<Organizer | null> {
        return this.BaseFetch(
            Organizer,
            `Organizer/GetOrganizerById` + '?' + (organizerId == undefined ? '' : `organizerId=${organizerId}`),
            'GET',
        );
    }
    public static async GetOrganizersForUser(): Promise<Organizer[]> {
        return this.BaseFetchArray(Organizer, `Organizer/GetOrganizersForUser`, 'GET');
    }
}
